import { SysDataBaseApi } from "../SysDataBaseApi";
import { Methods } from '@newview/infrastructure';
/**
 * Api
 */
export class ReportconfigApi extends SysDataBaseApi {
    public get ControllerName(): any {
        return 'Reportconfig'
    }
}
